import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

function AvisoPetExtra({ disclosure, valorExtraDep, onConfirmar }) {
  const valorFormatado = Number(valorExtraDep).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered size="xs">
      <ModalOverlay />
      <ModalContent borderRadius="1em" mx={4}>
        <ModalBody pt={6} pb={2}>
          <VStack spacing={3} align="center" textAlign="center">
            <Text fontSize="2xl">🐾</Text>
            <Text fontWeight="bold" fontSize="16" color="#585858">
              Adicionar pet ao plano
            </Text>
            <Text fontSize="14" color="#585858">
              Seu plano não inclui pet gratuito. Para adicionar um pet, será cobrada uma taxa de:
            </Text>
            <Text fontWeight="bold" fontSize="22" color="#5AB2AE">
              R$ {valorFormatado}
            </Text>
            <Text fontSize="13" color="#888">
              O pagamento pode ser feito via cartão de crédito ou Pix.
            </Text>
          </VStack>
        </ModalBody>

        <ModalFooter pb={5}>
          <Stack direction="column" spacing={2} w="100%">
            <Button
              colorScheme="teal"
              borderRadius="full"
              w="100%"
              onClick={() => {
                disclosure.onClose();
                onConfirmar();
              }}
            >
              Continuar para pagamento
            </Button>
            <Button
              variant="ghost"
              borderRadius="full"
              w="100%"
              color="#585858"
              onClick={disclosure.onClose}
            >
              Cancelar
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default AvisoPetExtra;
